export default __webpack_public_path__ + "static/media/balloon.1b3cf892.jpeg";